import { render, staticRenderFns } from "./PaginationBasic.vue?vue&type=template&id=6b292cb4&lang=pug"
import script from "./PaginationBasic.vue?vue&type=script&lang=js"
export * from "./PaginationBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b292cb4')) {
      api.createRecord('6b292cb4', component.options)
    } else {
      api.reload('6b292cb4', component.options)
    }
    module.hot.accept("./PaginationBasic.vue?vue&type=template&id=6b292cb4&lang=pug", function () {
      api.rerender('6b292cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaginationBasic.vue"
export default component.exports